<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    width="24"
    height="24"
  >
    <circle cx="6" cy="18" r="1.5" stroke-width="1.5" />
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M5.25 10.5A7.5 7.5 0 0112.75 18M5.25 5.25A12.75 12.75 0 0118 18"
    />
  </svg>
</template>

<script>
export default {
  name: 'Rss',
}
</script>
